import {
  Input,
  OnInit,
  Component,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { SubscriptionState } from '@shared/recurly/enums';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-subscription-state',
  templateUrl: './subscription-state.component.html',
  styleUrls: ['./subscription-state.component.scss'],
})
export class SubscriptionStateComponent implements OnInit, OnChanges {
  @Input() state?: SubscriptionState;
  @Input() canceledSubscriptionChange = false;

  icon = AppIcon;
  iconColor = AppIconColor;
  iconSize = AppIconSize;
  subscriptionState = SubscriptionState;
  stateToDisplay?: SubscriptionState;

  ngOnInit(): void {
    this.stateToDisplay = this.state;

    if (this.canceledSubscriptionChange) {
      this.stateToDisplay = SubscriptionState.canceled;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['canceledSubscriptionChange']?.currentValue) {
      if (this.canceledSubscriptionChange) {
        this.stateToDisplay = SubscriptionState.canceled;
      }
    } else {
      this.stateToDisplay = this.state;
    }
  }
}
